import { logger } from './logger';

/**
 * Version utility for accessing app version and environment information
 */

export const getAppVersion = (): string => {
  return import.meta.env.VITE_APP_VERSION || '1.0.0';
};

export const getAppEnvironment = (): string => {
  return import.meta.env.VITE_APP_ENV || 'development';
};

export const getFullVersionInfo = (): string => {
  const version = getAppVersion();
  const env = getAppEnvironment();
  return `${version} (${env})`;
};

export const isProduction = (): boolean => {
  return getAppEnvironment() === 'production';
};

export const isStaging = (): boolean => {
  return getAppEnvironment() === 'staging';
};

export const isDevelopment = (): boolean => {
  return getAppEnvironment() === 'development';
};

// Version info object for easy access
export const versionInfo = {
  version: getAppVersion(),
  environment: getAppEnvironment(),
  fullVersion: getFullVersionInfo(),
  isProduction: isProduction(),
  isStaging: isStaging(),
  isDevelopment: isDevelopment(),
};

// Console log version info (useful for debugging)
if (isDevelopment()) {
  logger.log('🚀 App Version Info:', versionInfo);
}
